import { useMemo } from "react";

import { useSearchParams } from "@/shims/next/navigation";

import type { SearchParams } from "@/types";

/**
 * The App Router handed every server component a `searchParams` object of
 * plain strings. This returns the same shape from the URL so the ported pages
 * could keep their original query-string handling untouched.
 */
export function useSearchParamsObject(): SearchParams {
  const params = useSearchParams();
  // `URLSearchParams` is mutable and stable per navigation; the string key is
  // what actually changes, so it drives the memo.
  const search = params.toString();

  return useMemo(() => {
    const result: Record<string, string> = {};
    new URLSearchParams(search).forEach((value, key) => {
      result[key] = value;
    });
    return result as SearchParams;
  }, [search]);
}